module.exports = __webpack_public_path__ + "img/bookcase.90d286fa.svg";